import React from "react";
import MaterialIcon from "../../../components/MaterialIcon";
import { Card, PrimaryButton } from "./CockpitPrimitives";
import CockpitKjuupIoOffer from "./CockpitKjuupIoOffer";
import CockpitKjuupPlusOffer from "./CockpitKjuupPlusOffer";

/**
 * Plain Kjuup user: book Kjuup.io right here and see the Kjuup+ offer with its
 * website prices. While Kjuup.io is not enabled for the user in the Admin
 * Panel, the same offer shows locked with a "Kjuup.io anfragen" request link.
 */
export function CockpitKjuupUpsell({
  strings,
  language,
  personaInfo,
  onRequestIo,
  onEnquirePlus,
  onIoActivated,
  showIo = true,
  showPlus = true,
}) {
  const canBookIo = personaInfo.stripeUiEnabled;
  return (
    <div className="cockpit-upsell-grid cockpit-upsell-grid--offer" id="cockpit-offers">
      {showPlus ? (
        <div id="cockpit-offer-kjuup-plus">
          <CockpitKjuupPlusOffer strings={strings} language={language} onRequest={onEnquirePlus} />
        </div>
      ) : null}
      {showIo ? (
        <div id="cockpit-offer-kjuup-io">
          <CockpitKjuupIoOffer
            strings={strings}
            language={language}
            canStartTrial={personaInfo.canStartTrial}
            onActivated={onIoActivated}
            locked={!canBookIo}
            onRequest={onRequestIo}
          />
        </div>
      ) : null}
    </div>
  );
}

/** Kjuup.io: finish the workspace setup (chats / email mode). */
export function CockpitSetupCard({ strings, onStart }) {
  return (
    <Card className="cockpit-upsell cockpit-upsell--inline cockpit-setup">
      <div className="cockpit-upsell-inline-icon">
        <MaterialIcon icon="tune" size={22} color="var(--kjuup-accent)" weight={400} />
      </div>
      <div className="cockpit-upsell-inline-text">
        <div className="cockpit-eyebrow cockpit-eyebrow--accent">Kjuup.io</div>
        <h3 className="cockpit-upsell-title">{strings.cockpit_setup_title || "Einrichtung abschließen"}</h3>
        <p className="cockpit-upsell-text">
          {strings.cockpit_setup_text ||
            "Entscheide, ob du Chats nutzen möchtest und ob Kjuup.io als E-Mail-Client arbeiten soll oder nur Projekte mit Tagesberichten."}
        </p>
      </div>
      <div className="cockpit-upsell-actions">
        <PrimaryButton icon="arrow_forward" onClick={onStart}>
          {strings.cockpit_setup_cta || "Jetzt einrichten"}
        </PrimaryButton>
      </div>
    </Card>
  );
}
